import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { WebSocketProvider } from "./contexts/WebSocketContext";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import VerifyPage from "./pages/VerifyPage";
import DonatePage from "./pages/DonatePage";
import Dashboard from "./pages/Dashboard";
import ReportsPage from "./pages/ReportsPage";
import IntelligencePage from "./pages/IntelligencePage";
import AdminUsersPage from "./pages/AdminUsersPage";
import AdminActivityPage from "./pages/AdminActivityPage";
import EPassPage from "./pages/EPassPage";
import LookupPage from "./pages/LookupPage";
import MyTrustPage from "./pages/MyTrustPage";
import AdminAppealsPage from "./pages/AdminAppealsPage";
import DoorbellVisitor from "./pages/DoorbellVisitor";
import DoorbellDemo from "./pages/DoorbellDemo";
import DoorbellTopupComplete from "./pages/DoorbellTopupComplete";
import StickerOrderComplete from "./pages/StickerOrderComplete";
import AdminStickerOrdersPage from "./pages/AdminStickerOrdersPage";
import DoorbellListener from "./components/doorbell/DoorbellListener";
import TermsPage from "./pages/TermsPage";
import TermsGate from "./components/TermsGate";
import { Toaster } from "sonner";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
        <WebSocketProvider>
        <TermsGate />
        <DoorbellListener />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/verify" element={<VerifyPage />} />
          <Route path="/donate" element={<DonatePage />} />
          <Route path="/d/:qrToken" element={<DoorbellVisitor />} />
          <Route path="/demo" element={<DoorbellDemo />} />
          <Route path="/doorbell/topup" element={<DoorbellTopupComplete />} />
          <Route path="/stickers/order-complete" element={<StickerOrderComplete />} />
          <Route path="/admin/stickers" element={<ProtectedRoute><AdminStickerOrdersPage /></ProtectedRoute>} />
          <Route path="/lookup" element={<LookupPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />
          <Route path="/intelligence" element={<ProtectedRoute><IntelligencePage /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute><AdminUsersPage /></ProtectedRoute>} />
          <Route path="/admin/activity" element={<ProtectedRoute><AdminActivityPage /></ProtectedRoute>} />
          <Route path="/epass" element={<ProtectedRoute><EPassPage /></ProtectedRoute>} />
          <Route path="/trust" element={<ProtectedRoute><MyTrustPage /></ProtectedRoute>} />
          <Route path="/admin/appeals" element={<ProtectedRoute><AdminAppealsPage /></ProtectedRoute>} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
        </WebSocketProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
